// extracted by mini-css-extract-plugin
export default {"tabs":"index_tabs_UyJ96","current":"index_current_u892R"};